import { render } from "./gallery_foto.vue?vue&type=template&id=66deb4f0&scoped=true"
import script from "./gallery_foto.vue?vue&type=script&lang=js"
export * from "./gallery_foto.vue?vue&type=script&lang=js"

import "./gallery_foto.vue?vue&type=style&index=0&id=66deb4f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66deb4f0"]])

export default __exports__